import { render, staticRenderFns } from "./CentersConfigurationGrid.vue?vue&type=template&id=77247786&"
import script from "./CentersConfigurationGrid.vue?vue&type=script&lang=js&"
export * from "./CentersConfigurationGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports